import styled from 'styled-components';
import { ifProp, switchProp } from 'styled-tools';
import alignmentStyles from 'admin-components/styles/alignment';
import layoutStyles from 'admin-components/styles/layout';
import StrippedBackElement from 'admin-components/utils/strippedBackElement';

import { colours } from 'themes/default';

export const Container = styled(StrippedBackElement)`
  background-color: ${ifProp('palette', colours.Shades.TintBlue10)};
  display: flex;
  flex-wrap: wrap;
  flex-direction: ${switchProp('orientation', {
    horizontal: 'row',
    vertical: 'column'
  })};
  min-height: 1em;

  ${alignmentStyles};
  ${layoutStyles};
`;
